"use client"

import React from "react";
import { FormattedMessage } from "react-intl";
import { 
  FaLink,
  FaPalette,
  FaBullhorn
 } from "react-icons/fa6";

const HowItWorks = () => (
  <section id="how-it-works" className="relative z-10 pt-[110px]">
    <div className="container">
      <div className="wow fadeInUp mx-auto mb-14 max-w-[690px] text-center lg:mb-[70px]" data-wow-delay=".2s">
        <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
          <FormattedMessage
            id="home-page-how-it-works-title"
          />
        </h2>
        <p className="text-base text-body">
          <FormattedMessage
            id="home-page-how-it-works-description"
          />
        </p>
      </div>
    </div>

    <div className="container max-w-[1390px]">
      <div className="px-5 bg-white rounded-2xl pt-14 pb-14 shadow-card dark:bg-dark dark:shadow-card-dark md:pb-1 lg:pt-20 lg:pb-5 xl:px-10">
        <div className="flex flex-wrap justify-center -mx-4">
          <div className="w-full px-4 md:w-1/2 lg:w-1/3">
            <div className="wow fadeInUp group mx-auto mb-[60px] max-w-[310px] text-center" data-wow-delay=".2s">
              <div
                className="mx-auto mb-8 flex h-[90px] w-[90px] items-center justify-center rounded-3xl bg-gray text-primary duration-300 group-hover:bg-primary group-hover:text-white dark:bg-[#2A2E44] dark:text-white dark:group-hover:bg-primary"
              >
                <FaLink
                  className="text-5xl"
                />
              </div>
              <h3 className="mb-4 text-xl font-semibold text-black dark:text-white sm:text-[22px] xl:text-[26px]">
                <FormattedMessage
                  id="home-page-how-it-works-step-one-title"
                />
              </h3>
              <p className="text-base text-body">
                <FormattedMessage
                  id="home-page-how-it-works-step-one-description"
                />
              </p>
            </div>
          </div>

          <div className="w-full px-4 md:w-1/2 lg:w-1/3">
            <div className="wow fadeInUp group mx-auto mb-[60px] max-w-[310px] text-center" data-wow-delay=".3s">
              <div
                className="mx-auto mb-8 flex h-[90px] w-[90px] items-center justify-center rounded-3xl bg-gray text-primary duration-300 group-hover:bg-primary group-hover:text-white dark:bg-[#2A2E44] dark:text-white dark:group-hover:bg-primary"
              >
                <FaPalette
                  className="text-5xl"
                />
              </div>
              <h3 className="mb-4 text-xl font-semibold text-black dark:text-white sm:text-[22px] xl:text-[26px]">
                <FormattedMessage
                  id="home-page-how-it-works-step-two-title"
                />
              </h3>
              <p className="text-base text-body">
                <FormattedMessage
                  id="home-page-how-it-works-step-two-description"
                />
              </p>
            </div>
          </div>

          <div className="w-full px-4 md:w-1/2 lg:w-1/3">
            <div className="wow fadeInUp group mx-auto mb-[60px] max-w-[310px] text-center" data-wow-delay=".4s">
              <div
                className="mx-auto mb-8 flex h-[90px] w-[90px] items-center justify-center rounded-3xl bg-gray text-primary duration-300 group-hover:bg-primary group-hover:text-white dark:bg-[#2A2E44] dark:text-white dark:group-hover:bg-primary"
              >
                <FaBullhorn
                  className="text-5xl"
                />
              </div>
              <h3 className="mb-4 text-xl font-semibold text-black dark:text-white sm:text-[22px] xl:text-[26px]">
                <FormattedMessage
                  id="home-page-how-it-works-step-tree-title"
                />
              </h3>
              <p className="text-base text-body">
                <FormattedMessage
                  id="home-page-how-it-works-step-tree-description"
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="absolute left-0 hidden -top-28 -z-10 md:block">
      <svg width="632" height="1179" viewBox="0 0 632 1179" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.25" filter="url(#filter0_f_38_24)">
          <circle cx="42.5" cy="589.5" r="329.5" fill="url(#paint0_linear_38_24)" />
        </g>
        <defs>
          <filter id="filter0_f_38_24" x="-547" y="0" width="1179" height="1179" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="130" result="effect1_foregroundBlur_38_24" />
          </filter>
          <linearGradient id="paint0_linear_38_24" x1="-366.218" y1="919" x2="451.176" y2="349.901" gradientUnits="userSpaceOnUse">
            <stop stopColor="#f55c00" />
            <stop offset="0.541667" stopColor="#ff9640" />
            <stop offset="1" stopColor="#ffd27f" />
          </linearGradient>
        </defs>
      </svg>
    </div>

    <div className="absolute right-0 top-20 -z-10">
      <svg width="637" height="1277" viewBox="0 0 637 1277" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.2" filter="url(#filter0_f_38_23)">
          <circle cx="638.5" cy="638.5" r="388.5" fill="url(#paint0_linear_38_23)" />
        </g>
        <defs>
          <filter id="filter0_f_38_23" x="0" y="0" width="1277" height="1277" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="125" result="effect1_foregroundBlur_38_23" />
          </filter>
          <linearGradient id="paint0_linear_38_23" x1="250" y1="250" x2="1168.59" y2="782.957" gradientUnits="userSpaceOnUse">
            <stop stopColor="#f55c00" />
            <stop offset="1" stopColor="#FFC960" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  </section>
);

export default HowItWorks;